<template>
    <AppCard elevation="0" class="projects-table-card rounded-lg">
      <!-- Sort is handled by ProjectsTableHeader -->
      <v-data-table :items="projects"
                    :headers="headers"
                    :page="pagination.page"
                    :items-per-page="pagination.pageSize"
                    :hide-default-footer="hidePagination"
                    :loading="isPending && projects[0]?.name === null"
      >

        <template #loading>
            <v-skeleton-loader v-for="n in pagination.pageSize" :key="n" type="text" />
        </template>


        <template #headers="{ columns }">
          <ProjectsTableHeader v-for="column in columns"
                               :key="column.value"
                               :column-name="column.value"
                               :fit-width="column.fitWidth"
                               :header="column.title"
                               :sortable="column.sortable"
                               @sort="$emit('sort', $event)"
          />
        </template>
        <template #item="{item}">
          <ProjectsTableItem :room="item"
                             @click="accessRoom(item)"
          />
        </template>

      <template #bottom v-if="!hidePagination">
        <div class="d-flex justify-end my-2">
          <AppPagination
            :current-page="pagination.page"
            :page-size="pagination.pageSize"
            :total="pagination.itemCount"
            @update:current-page="$emit('update:current-page', $event)"
            @update:page-size="$emit('update:page-size', $event)">
          </AppPagination>
        </div>
      </template>
    </v-data-table>
  </AppCard>
</template>

<script>
import { mapMutations } from 'vuex'

import AppCard from '@/common/AppCard.vue'
import AppPagination from '@/common/pagination/AppPagination.vue'
import { getRoomRouteType } from '@/common/utils/rooms'
import { ROOM_ROUTE_NAME } from '@/router/routerData'
import { SET_ROOM_UNDER_NDA_DIALOG } from '@/store/modules/room/mutation_types'

import ProjectsTableHeader from './ProjectsTableHeader.vue'
import ProjectsTableItem from './ProjectsTableItem.vue'

export default {
  name: 'ProjectsTable',
  components: {
    AppPagination,
    AppCard,
    ProjectsTableHeader,
    ProjectsTableItem,
  },
  props: {
    projects: {
      type: Array,
      required: true,
    },
    hideMembers: {
      type: Boolean,
      default: false,
    },
    pagination: {
      type: Object,
      required: true,
    },
    hidePagination: {
      type: Boolean,
      default: false,
    },
    isPending: {
      type: Boolean,
      default: false,
    },
  },
  data () {
    return {
      headers: [
        {
          title: this.$t('projects.table.ProjectsTable.header.type'),
          value: 'type',
          sortable: true,
        },
        {
          title: this.$t('projects.table.ProjectsTable.header.name'),
          value: 'name',
          sortable: true,
        },
        {
          title: this.$t('projects.table.ProjectsTable.header.access'),
          value: this.hideMembers ? 'hiddenNbParticipants' : 'nbParticipants',
        },
        {
          title: this.$t('projects.table.ProjectsTable.header.label'),
          value: 'label',
          sortable: true,
        },
        {
          title: this.$t('projects.table.ProjectsTable.header.cmRef'),
          value: 'cmRef',
          sortable: true,
        },
        {
          title: this.$t('projects.table.ProjectsTable.header.createdAt'),
          value: 'creationDate',
          sortable: true,
        },
        {
          title: this.$t('projects.table.ProjectsTable.header.expectedClosingDate'),
          value: 'expectedClosingDate',
          sortable: true,
        },
        {
          title: this.$t('projects.table.ProjectsTable.header.documents'),
          value: 'documentsCount',
        },
        {
          title: this.$t('projects.table.ProjectsTable.header.qa'),
          value: 'qaCount',
        },
        {
          title: this.$t('projects.table.ProjectsTable.header.signedDocuments'),
          value: 'originalsCount',
        },
        {
          title: this.$t('projects.table.ProjectsTable.header.tasks'),
          value: 'tasksCount',
        },
        {
          title: this.$t('projects.table.ProjectsTable.header.signaturesPending'),
          value: 'signaturesPendingCount',
        },
      ],
      ROOM_ROUTE_NAME,
    }
  },
  methods: {
    ...mapMutations('room', [SET_ROOM_UNDER_NDA_DIALOG]),
    accessRoom (room) {
      if (!room.needToSignNda) {
        this.$router.push({ name: ROOM_ROUTE_NAME, params: { mnemo: room.mnemo, roomType: getRoomRouteType(room) } })
      } else {
        this.SET_ROOM_UNDER_NDA_DIALOG({ mnemo: room.mnemo, isOpen: true })
      }
    },
  },
}
</script>

<style scoped lang="scss">
.projects-table-card {
  padding: 0 !important;
}

:deep(.v-table .v-table__wrapper > table > tbody > tr > td) {
  border-bottom: solid 1px rgb(var(--v-theme-border-primary)) !important;
}
</style>
